<template>
    <div v-if="isMounted" style="height: calc(100vh - 40px - 36px - 10px - 10px);overflow-y: auto">
        <div >
            <div class="m-portlet m-b-10">
                <div class="m-portlet__body">
                    <el-form label-position="right">
                        <el-row :gutter="20">
                            <el-col :span="4">
                                <el-form-item label="学期类型">
                                    <el-select v-model="filter.semester_type_id" placeholder="请选择学期类型" clearable
                                               @change="handleSemesters()" style="width: 160px">
                                        <el-option
                                                v-for="item in semester_types"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="学期">
                                    <el-select v-model="filter.semester_id" placeholder="请选择学期" clearable
                                               @change="handleShow()" style="width: 160px">
                                        <el-option
                                                v-for="item in semesters"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <div v-loading="loading">
                <div class="m-portlet__body">
                    <el-row :gutter="20">
                        <!--<el-col :span="6">-->
                        <!--<div class="m-portlet m-portlet&#45;&#45;head-sm">-->
                        <!--<div class="m-portlet__head">-->
                        <!--<div class="m-portlet__head-caption">-->
                        <!--<div class="m-portlet__head-title">-->
                        <!--<h3 class="m-portlet__head-text">-->
                        <!--{{$store.state.user.name}}-->
                        <!--</h3>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--<div class="m-portlet__body">-->
                        <!--<el-row :gutter="20">-->
                        <!--<el-col :span="8">-->
                        <!--<el-badge >-->
                        <!--<div class="tag-success-badge" >待办</div>-->
                        <!--</el-badge>-->
                        <!--</el-col>-->
                        <!--<el-col :span="8">-->
                        <!--<el-badge  >-->
                        <!--<div class="tag-warning-badge" >催办</div>-->
                        <!--</el-badge>-->
                        <!--</el-col>-->
                        <!--<el-col :span="8">-->
                        <!--<el-badge >-->
                        <!--<div class="tag-danger-badge" >逾期</div>-->
                        <!--</el-badge>-->
                        <!--</el-col>-->
                        <!--</el-row>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--&lt;!&ndash;<Task_TeacherAskForLeaving></Task_TeacherAskForLeaving>&ndash;&gt;-->
                        <!--</el-col>-->
                        <el-col :span="6" v-if="powers.includes(181)">
                            <Task_Consult></Task_Consult>
                        </el-col>
                        <el-col :span="6">
                            <Task_Refund></Task_Refund>
                        </el-col>
                        <el-col :span="6">
                            <Task_StudentCart></Task_StudentCart>
                        </el-col>

                        <el-col :span="6">
                            <Task_StudentSituation></Task_StudentSituation>
                        </el-col>

                        <el-col :span="6">
                            <Task_NewStudent></Task_NewStudent>
                        </el-col>

                        <el-col :span="6">
                            <Task_UntreatedStudent></Task_UntreatedStudent>
                        </el-col>

                        <el-col :span="6">
                            <Task_ClassChange></Task_ClassChange>
                        </el-col>

                        <el-col :span="6">
                            <Task_LeavingStudent></Task_LeavingStudent>
                        </el-col>

                        <el-col :span="6">
                            <Task_AbsentStudent></Task_AbsentStudent>
                        </el-col>

                        <el-col :span="6">
                            <Task_ApplyLeaveStudent></Task_ApplyLeaveStudent>
                        </el-col>
                        <el-col :span="6">
                            <Task_ApplyRefundStudent></Task_ApplyRefundStudent>
                        </el-col>
                        <el-col :span="6">
                            <Task_LeavingFirst></Task_LeavingFirst>
                        </el-col>
                        <el-col :span="6">
                            <Task_LeavingSecond></Task_LeavingSecond>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import Task_TeacherAskForLeaving from './componments/Task_TeacherAskForLeaving'
    import Task_Refund from './componments/Task_Refund'
    import Task_StudentCart from './componments/Task_StudentCart'
    import Task_NewStudent from './componments/Task_NewStudent'
    import Task_StudentSituation from './componments/Task_StudentSituation'
    import Task_ClassChange from './componments/Task_ClassChange'
    import Task_AbsentStudent from './componments/Task_AbsentStudent'
    import Task_LeavingStudent from './componments/Task_LeavingStudent'
    import Task_LeavingFirst from './componments/Task_LeavingFirst'
    import Task_LeavingSecond from './componments/Task_LeavingSecond'
    import Task_UntreatedStudent from './componments/Task_UntreatedStudent'
    import Task_ApplyLeaveStudent from './componments/Task_ApplyLeaveStudent'
    import Task_ApplyRefundStudent from './componments/Task_ApplyRefundStudent'
    import Task_Consult from './componments/Task_Consult'
    export default {
        name: "Home",
        data() {
            return {
                path: "/home",
                isMounted: false,
                task_scroll:true,
                filter:{
                  semester_type_id:'',
                  semester_id:''
                },
                semesters:[],
                semester_types:[],

                Task_Refund: {
                    data: []
                },
                Task_StudentCart: {
                    data: []
                },
                Task_NewStudent: {
                    data: []
                },
                Task_StudentSituation: {
                    data: [],
                    loading: false,
                    count: 10,
                },
                Task_ClassChange: {
                    data: []
                },
                Task_LeavingStudent: {
                    data: []
                },
                Task_AbsentStudent: {
                    data: []
                },
                Task_UntreatedStudent: {
                    data: []
                },
                Task_ApplyLeaveStudent: {
                    data: {}
                },
                Task_ApplyRefundStudent: {
                    data: {}
                },
                Task_LeavingFirst: {
                    data: []
                },
                Task_LeavingSecond: {
                    data: []
                },
                Task_Consult: {
                    data: []
                },
                loading: false,
            }
        },
        created() {
            this.handleCreate();
            this.handleShow();
        },
        mounted() {
            this.isMounted = true;
        },
        components: {
            "Task_TeacherAskForLeaving": Task_TeacherAskForLeaving,
            "Task_Refund": Task_Refund,
            "Task_StudentCart": Task_StudentCart,
            'Task_NewStudent': Task_NewStudent,
            'Task_StudentSituation': Task_StudentSituation,
            'Task_ClassChange': Task_ClassChange,
            'Task_LeavingStudent': Task_LeavingStudent,
            'Task_AbsentStudent': Task_AbsentStudent,
            "Task_UntreatedStudent": Task_UntreatedStudent,
            "Task_ApplyLeaveStudent": Task_ApplyLeaveStudent,
            "Task_ApplyRefundStudent": Task_ApplyRefundStudent,
            'Task_LeavingFirst':Task_LeavingFirst,
            'Task_LeavingSecond':Task_LeavingSecond,
            'Task_Consult':Task_Consult
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleShow() {
                this.loading=true
                this.$wApi.send(this.path, 'init',
                    {'currentPageSize': 10, 'currentPage': 1,'semester_id':this.filter.semester_id});
            },
            handleSemesters() {
                this.filter.semester_id='';
                this.$wApi.send(this.path, 'get_semesters_by_semester_type',
                    {'semester_type_id': this.filter.semester_type_id});
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        if (Object.keys(data.refunds).length > 0) {
                            this.Task_Refund.data = data.refunds;
                        } else {
                            this.Task_Refund.data = new Object();
                        }
                        if (Object.keys(data.studentCarts).length > 0) {
                            this.Task_StudentCart.data = data.studentCarts;
                        } else {
                            this.Task_StudentCart.data = new Object();
                        }
                        if (Object.keys(data.newStudents).length > 0) {
                            this.Task_NewStudent.data = data.newStudents;
                        } else {
                            this.Task_NewStudent.data = new Object();
                        }
                        if (Object.keys(data.studentSituations).length > 0) {
                            this.Task_StudentSituation.data = data.studentSituations;
                        } else {
                            this.Task_StudentSituation.data = new Object();
                        }
                        if (Object.keys(data.classChanges).length > 0) {
                            this.Task_ClassChange.data = data.classChanges;
                        } else {
                            this.Task_ClassChange.data = new Object();
                        }
                        if (Object.keys(data.leavingStudents).length > 0) {
                            this.Task_LeavingStudent.data = data.leavingStudents;
                        } else {
                            this.Task_LeavingStudent.data = new Object();
                        }
                        if (Object.keys(data.absentStudents).length > 0) {
                            this.Task_AbsentStudent.data = data.absentStudents;
                        } else {
                            this.Task_AbsentStudent.data = new Object();
                        }
                        if (Object.keys(data.untreatedStudents).length > 0) {
                            this.Task_UntreatedStudent.data = data.untreatedStudents;
                        } else {
                            this.Task_UntreatedStudent.data = new Object();
                        }
                        if (Object.keys(data.applyLeaveStudents).length > 0) {
                            this.Task_ApplyLeaveStudent.data = data.applyLeaveStudents
                        } else {
                            this.Task_ApplyLeaveStudent.data = new Object();
                        }
                        if (Object.keys(data.applyRefundStudents).length > 0) {
                            this.Task_ApplyRefundStudent.data = data.applyRefundStudents
                        } else {
                            this.Task_ApplyRefundStudent.data = new Object();
                        }
                        if (Object.keys(data.leavingFirsts).length > 0) {
                            this.Task_LeavingFirst.data = data.leavingFirsts
                        } else {
                            this.Task_LeavingFirst.data = new Object();
                        }
                        if (Object.keys(data.leavingSeconds).length > 0) {
                            this.Task_LeavingSecond.data = data.leavingSeconds
                        } else {
                            this.Task_LeavingSecond.data = new Object();
                        }
                        if (Object.keys(data.consults).length > 0) {
                            this.Task_Consult.data = data.consults
                        } else {
                            this.Task_Consult.data = new Object();
                        }
                        this.semester_types=data.semester_types
                        this.semesters=data.semesters
                        this.loading = false;
                        this.task_scroll=true;
                        break;
                    case 'init_error':
                        this.task_scroll=false;
                        this.loading = false;
                        break;
                    case 'read_classChange':
                        this.$set(this.Task_ClassChange.data, data.classChange.id, data.classChange);
                        break;
                    case 'read_studentSituation':
                        this.$set(this.Task_StudentSituation.data, data.studentSituation.id, data.studentSituation);
                        break;
                    case 'read_newStudent':
                        this.$set(this.Task_NewStudent.data, data.newStudent.id, data.newStudent);
                        break;
                    case 'read_consult':
                        this.$set(this.Task_Consult.data, data.consult.id, data.consult);
                        break;
                    case 'init_absentStudent':
                        for (let key in data.absentStudents) {
                            this.$set(this.Task_AbsentStudent.data, key, data.absentStudents[key]);
                        }
                        break;
                    case 'init_refund':
                        for (let key in data.refunds) {
                            this.$set(this.Task_Refund.data, key, data.refunds[key]);
                        }
                        break;
                    case 'init_studentCart':
                        for (let key in data.studentCarts) {
                            this.$set(this.Task_StudentCart.data, key, data.studentCarts[key]);
                        }
                        break;
                    case 'init_newStudent':
                        for (let key in data.newStudents) {
                            this.$set(this.Task_NewStudent.data, key, data.newStudents[key]);
                        }
                        this.Task_NewStudent.loading = false;
                        break;
                    case 'init_studentSituation':
                        for (let key in data.studentSituations) {
                            this.$set(this.Task_StudentSituation.data, key, data.studentSituations[key]);
                        }
                        break;
                    case 'init_classChange':
                        for (let key in data.classChanges) {
                            this.$set(this.Task_ClassChange.data, key, data.classChanges[key]);
                        }
                        break;
                    case 'init_leavingStudent':
                        for (let key in data.leavingStudents) {
                            this.$set(this.Task_LeavingStudent.data, key, data.leavingStudents[key]);
                        }
                        break;
                    case 'init_untreatedStudent':
                        for (let key in data.untreatedStudents) {
                            this.$set(this.Task_UntreatedStudent.data, key, data.untreatedStudents[key]);
                        }
                        break;
                    case 'init_applyLeaveStudent':
                        for (let key in data.applyLeaveStudents) {
                            this.$set(this.Task_ApplyLeaveStudent.data, key, data.applyLeaveStudents[key]);
                        }
                        break;
                    case 'init_applyRefundStudent':
                        for (let key in data.applyRefundStudents) {
                            this.$set(this.Task_ApplyRefundStudent.data, key, data.applyRefundStudents[key]);
                        }
                        break;
                    case 'init_leavingFirst':
                        for (let key in data.leavingFirsts) {
                            this.$set(this.Task_LeavingFirst.data, key, data.leavingFirsts[key]);
                        }
                        break;
                    case 'init_leavingSecond':
                        for (let key in data.leavingSeconds) {
                            this.$set(this.Task_LeavingFirst.data, key, data.leavingSeconds[key]);
                        }
                        break;
                    case 'init_consult':
                        for (let key in data.consults) {
                            this.$set(this.Task_Consult.data, key, data.consults[key]);
                        }
                        break;
                    case 'store_absentStudent':
                        this.$set(this.Task_AbsentStudent.data, data.absentStudent.id, data.absentStudent);
                        break;

                    case 'store_refund':
                        this.$set(this.Task_Refund.data, data.refund.id, data.refund);
                        break;

                    //购物车操作
                    case 'store_studentCart':
                        this.$set(this.Task_StudentCart.data, data.studentCart.id, data.studentCart);
                        break;
                    case 'update_studentCart':
                        this.$set(this.Task_StudentCart.data, data.studentCart.id, data.studentCart);
                        break;
                    case 'delete_studentCart':
                        this.$delete(this.Task_StudentCart.data, data.student_id);
                        break;

                    //申请操作
                    case 'store_applyLeaveStudent':
                        Object.keys(data.applyLeaveStudents).forEach((item) => {
                            this.$set(this.Task_ApplyLeaveStudent.data, item, data.applyLeaveStudents[item]);
                        });
                        break;
                    case 'delete_applyLeaveStudent':
                        this.$delete(this.Task_ApplyLeaveStudent.data, data.applyLeaveStudent_id);
                        break;
                    case 'store_applyRefundStudent':
                        Object.keys(data.applyRefundStudents).forEach((item) => {
                            this.$set(this.Task_ApplyRefundStudent.data, item, data.applyRefundStudents[item]);
                        });
                        break;
                    case 'delete_applyRefundStudent':
                        this.$delete(this.Task_ApplyRefundStudent.data, data.applyRefundStudent_id);
                        break;


                    case 'store_newStudent':
                        this.$set(this.Task_NewStudent.data, data.student.id, data.student);
                        break;
                    case 'store_studentSituation':
                        this.$set(this.Task_StudentSituation.data, data.studentSituation.id, data.studentSituation);
                        break;

                    case 'store_classChange':
                        this.$set(this.Task_ClassChange.data, data.classChange.id, data.classChange);
                        break;

                    case 'store_leavingStudent':
                        this.$set(this.Task_LeavingStudent.data, data.leavingStudent.id, data.leavingStudent);
                        break;
                    case 'delete_leavingStudent':
                        this.$delete(this.Task_LeavingStudent.data, data.leavingStudent_id);
                        break;
                    case 'delete_untreatedStudent':
                        this.$delete(this.Task_UntreatedStudent.data, data.untreatedStudent_id);
                        break;
                    case 'get_semesters_by_semester_type':
                        this.semesters=data.semesters;
                        break;
                }
            },
        }
    }
</script>
